import React, { useState } from 'react'
import RichText from '../RichText'
import SvgIcon from '../SvgIcon'
import styles from './index.module.scss'
import classNames from 'classnames'

const DataStrip = ({ dataStrip, source, className }) => {
  const [isExpanded, setIsExpanded] = useState(false)

  const handleToggle = () => {
    setIsExpanded(!isExpanded)
  }

  if (dataStrip.length <= 0) {
    return null
  }

  return (
    <div className={`${styles.fullBleed} w-full bg-blue-135`}>
      {dataStrip.map((item, i) => (
        <RichText
          key={'dataStripItem' + i}
          contentData={item}
          className={classNames(`${styles.contentStrip} ${className}`)}
        />
      ))}
      {source && (
        <div className="my-4 inline-block" onClick={handleToggle}>
          {isExpanded ? (
            <>
              <p className="inline-flex items-center text-blue-610 hover:cursor-pointer">
                Hide source
                <span className="inline-block" style={{ marginLeft: '4px' }}>
                  <SvgIcon className="h-16 w-4 rotate-180" name="arrowDown" />
                </span>
              </p>
              <RichText
                contentData={source}
                className={classNames(`${styles.contentStrip} ${className}`)}
              />
            </>
          ) : (
            <p className="inline-flex items-center text-blue-610 hover:cursor-pointer">
              Show source
              <span className="inline-block" style={{ marginLeft: '4px' }}>
                <SvgIcon className="h-16 w-4" name="arrowDown" />
              </span>
            </p>
          )}
        </div>
      )}
    </div>
  )
}

export default React.memo(DataStrip)
